export default __webpack_public_path__ + "static/media/app-notification.8791d4b1.svg";